export enum StockPriceMovement {
  Up = 'Up',
  Down = 'Down',
  Flat = 'Flat',
}

export interface BidOfferItemList {
  volume: number[];
  frequency: number[];
  price: number[];
}

export interface TotalFrequencyVolumeItem {
  frequency: number;
  volume: number;
}

export interface BidOfferTotalFrequencyVolume {
  bid: TotalFrequencyVolumeItem;
  offer: TotalFrequencyVolumeItem;
}
